// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate.
  *
  */

import React from 'react';

import { ReactComponent as JiraComponent } from './Jira.svg';

import Icon, { TIconProps } from '../Icon';

export const IconJira = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <JiraComponent/>
  </Icon>
));
